import { useEffect, useRef, useState, useContext } from 'react';

import styles from './SettingsComponent.module.css';
import { GlobalContext } from "../../contexts/globalContext";

import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StationListComponent from './StationListComponent';

const SettingsComponent = ({ showRoomSettings, openStationsMap, setOpenStationsMap, onlineDevices, setOnlineDevices, deviceToStart, setDeviceToStart, desksIdsForAnim, setDesksIdsForAnim,
    onDeskClicked }) => {

    const { deskData, socketRef, appHeight, localSocketRef } = useContext(GlobalContext)

    const [outputVolume, setOutputVolume] = useState()
    const [inputVolume, setInputVolume] = useState()
    const [inputVolumeCurrent, setInputVolumeCurrent] = useState(10)
    const [outputVolumeCurrent, setOutputVolumeCurrent] = useState(10)
    const [allDeskIdsInRoom, setAllDeskIdsInRoom] = useState([])
    const [powerOnAllFlashing, setPowerOnAllFlashing] = useState(false)

    const shutdownAllRef = useRef();
    const powerOnAllRef = useRef();
    const emitTimeoutRef = useRef();


    useEffect(() => {
        var showShutdownAll = false;
        var showPowerOnAll = false;

        for (let index = 0; index < allDeskIdsInRoom.length; index++) {
            const deviceId = allDeskIdsInRoom[index].deviceId;
            if (deviceId !== deskData.deviceId) {
                if (onlineDevices.includes(deviceId)) {
                    showShutdownAll = true;
                } else {
                    showPowerOnAll = true;
                }
            }
        }

        if (shutdownAllRef.current) {
            shutdownAllRef.current.className = showShutdownAll ? styles.on : styles.on_disabled;
            powerOnAllRef.current.className = showPowerOnAll ? styles.on : styles.on_disabled;
        }

        if (!showPowerOnAll) setPowerOnAllFlashing(false)

        clearTimeout(emitTimeoutRef.current);

    }, [onlineDevices, allDeskIdsInRoom]);

    useEffect(() => {
        if (localSocketRef.current?.connected) {

            localSocketRef.current.emit("volume:getSpeakerMasterVolume", (volume) => {
                setOutputVolume(volume);
            });

            localSocketRef.current.emit("volume:getMicMasterVolume", (volume) => {
                setInputVolume(volume);
            });

        }

        socketRef.current.emit('GET_ALL_ONLINE_DEVICES', callback => {
            setOnlineDevices(callback);
        })

        socketRef.current.on('DEVICE_ONLINE', (onlineDevs) => {
            setOnlineDevices(onlineDevs);
        })

        socketRef.current.on('DEVICE_OFFLINE', (onlineDevs) => {
            setOnlineDevices(onlineDevs);
        })

        return () => {
            socketRef.current?.off('DEVICE_ONLINE');
            socketRef.current?.off('DEVICE_OFFLINE');
            socketRef.current?.off('MASTER_VOLUME');
        }

    }, []);

    const ShutdownAll = () => {
        for (let index = 0; index < allDeskIdsInRoom.length; index++) {
            const deviceId = allDeskIdsInRoom[index].deviceId;
            if (deviceId !== deskData.deviceId && onlineDevices.includes(deviceId)) {
                setTimeout(() => {
                    socketRef.current.emit("SHUTDOWN", deviceId);
                }, index * 200)
            }
        }
        setDesksIdsForAnim([]);
    }

    const WolAll = () => {
        for (let index = 0; index < allDeskIdsInRoom.length; index++) {
            const deviceId = allDeskIdsInRoom[index].deviceId;

            if (deviceId !== deskData.deviceId) {
                setTimeout(() => {
                    setDeviceToStart(deviceId);
                    if (localSocketRef.current?.connected) {
                        localSocketRef.current.emit("systemInfo:wakeOnLan", deviceId);
                    }
                    setDesksIdsForAnim((desksId) => [...desksId, allDeskIdsInRoom[index]._id])
                }, index * 200)
            }
        }
        setPowerOnAllFlashing(true)
    }

    const handleChange = (event, setProgress) => {
        setProgress(event.target.value);
    }

    useEffect(() => {
        if (outputVolume && localSocketRef.current?.connected) {
            localSocketRef.current.emit("volume:setSpeakerMasterVolume", outputVolume / 100);
        }
    }, [outputVolume])

    useEffect(() => {
        if (inputVolume && localSocketRef.current?.connected) {
            localSocketRef.current.emit("volume:setMicMasterVolume", inputVolume / 100);
        }
    }, [inputVolume])

    const volumeButtonClicked = () => {
        setOutputVolumeCurrent(outputVolume);
        if (outputVolume === 0) {
            setOutputVolume(outputVolumeCurrent);
        } else {
            setOutputVolume(0);
        }
    }

    const micButtonClicked = () => {
        setInputVolumeCurrent(inputVolume);
        if (inputVolume === 0) {
            setInputVolume(inputVolumeCurrent);
        } else {
            setInputVolume(0);
        }
    }

    return (
        <div className={styles.component} style={{ left: "143px", bottom: `${showRoomSettings ? 0 : -appHeight}px`, opacity: `${showRoomSettings ? 1 : 0}` }}>
            <div className={styles.header}>SETTINGS</div>
            <div className={styles.column_list} style={{ flex: "1", maxHeight: "calc(100% - 300px)" }}>
                <div className={styles.table}>
                    {deskData && <StationListComponent desksIdsForAnim={desksIdsForAnim} setDesksIdsForAnim={setDesksIdsForAnim} deviceToStart={deviceToStart} setDeviceToStart={setDeviceToStart}
                        setAllDeskIdsInRoom={setAllDeskIdsInRoom} onlineDevices={onlineDevices} onDeskClicked={onDeskClicked} setPowerOnAllFlashing={setPowerOnAllFlashing}
                        powerOnAllRef={powerOnAllRef} />}
                    <div className={styles.buttons_panel}>
                        <div className={styles.title}>POWER ON / OFF</div>
                        <div className={styles.subtitle}>Toggle the power of individual conference systems.</div>
                        <div className={styles.buttonsx}>
                            <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                                <div ref={shutdownAllRef} className={styles.on_disabled} onClick={() => ShutdownAll()}>
                                    <i className="fa-solid fa-power-off"></i>
                                    <div className={styles.text}>SHUT DOWN ALL</div>
                                </div>

                                <div ref={powerOnAllRef} className={powerOnAllFlashing ? styles.colorCycle : ""} onClick={() => WolAll()}>
                                    <i className="fa-solid fa-power-off"></i>
                                    <div className={styles.text}>POWER ON ALL</div>
                                </div>
                            </div>

                            <div className={deskData ? styles.open : styles.on_disabled} style={{ width: 267 }} onClick={() => setOpenStationsMap(!openStationsMap)}>
                                <i className="fa-solid fa-map-pin"></i>
                                <div className={styles.text}>OPEN STATIONS MAP</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.separator}></div>
            <div className={styles.column} style={{ height: "900px" }}>
                <div className={styles.sliders}>
                    <div className={styles.slider}>
                        <div className={styles.title}>SOUND</div>
                        <div className={styles.subtitle}>Adjust the volume level.</div>
                        <FontAwesomeIcon className={styles.volumeIcon} icon={byPrefixAndName.fas[outputVolume > 0 ? 'volume' : 'volume-slash']} style={{ color: outputVolume > 0 ? '#181134' : '#ffffff' }} onClick={volumeButtonClicked} />
                        <input type="range"
                            className={styles.slider_input}
                            min="0"
                            max="100"
                            step="1"
                            value={outputVolume}
                            onChange={(e) => handleChange(e, setOutputVolume)}
                            style={{
                                background: `linear-gradient(to right, #726fa8 ${outputVolume}%, #726fa84D ${outputVolume}%)`
                            }}

                        ></input>
                    </div>
                    <div className={styles.slider}>
                        <div className={styles.title}>MICROPHONE</div>
                        <div className={styles.subtitle}>Adjust your microphone sensitivity.</div>
                        <FontAwesomeIcon className={styles.volumeIcon} icon={byPrefixAndName.fas[inputVolume > 0 ? 'microphone' : 'microphone-slash']} style={{ color: inputVolume > 0 ? '#181134' : '#ffffff' }} onClick={micButtonClicked} />
                        <input
                            className={styles.slider_input}
                            type="range"
                            min="0"
                            max="100"
                            step="1"
                            value={inputVolume}
                            onChange={(e) => handleChange(e, setInputVolume)}
                            style={{
                                background: inputVolume > 0
                                    ? `linear-gradient(to right, #726fa8 ${inputVolume}%, #726fa84D ${inputVolume}%)`
                                    : '#726fa84D',
                            }}
                        ></input>
                    </div>
                </div>


            </div>
        </div>
    );
}

export default SettingsComponent;
